import { EModalSize, EPredefinedModalIds } from 'src/constants/modals';
import React, { useEffect, useRef } from 'react';
import { closeModal, openModal } from 'src/redux/modals/modals.slice';

import { BaseButtonSquare } from 'src/components/BaseButtonSquare';
import { BaseGenericModal } from 'src/components/BaseGenericModal';
import { TModalEmbedLegendsProps } from './ModalEmbedLegends.types';
import classnames from 'classnames';
import s from './ModalEmbedLegends.module.scss';
import { selectIsModalOpened } from 'src/redux/modals/modals.selectors';
import { useAppDispatch } from 'src/redux/store';
import { useConfigurationFlowState } from 'src/hooks/useConfigurationFlowState';
import { useSelector } from 'react-redux';

export const ModalEmbedLegends: React.FC<TModalEmbedLegendsProps> = () => {
  const dispatch = useAppDispatch();
  const modalRef = useRef<HTMLDivElement>(null);
  const { modalsEmbedShow } = useConfigurationFlowState();
  const isModalEmbedLegendsOpened = useSelector(
    selectIsModalOpened(EPredefinedModalIds.MODAL_EMBED_LEGENDS),
  );

  const legends = [
    {
      title: 'Exporting Energy',
      color: 'linear-gradient(176.62deg, #5DE273 24.03%, #1A48ED 104.62%)',
    },
    {
      title: 'Importing Energy',
      color: 'linear-gradient(176.62deg, #FC1355 24.03%, #1A48ED 104.62%)',
    },
    {
      title: 'Self Sufficient',
      color: 'linear-gradient(176.62deg, #466CF5 24.03%, #1A48ED 104.62%)',
    },
  ];

  const handleCloseClick = () => {
    if (!isModalEmbedLegendsOpened) {
      dispatch(openModal(EPredefinedModalIds.MODAL_EMBED_LEGENDS));
    } else {
      dispatch(closeModal(EPredefinedModalIds.MODAL_EMBED_LEGENDS));
    }
  };

  useEffect(() => {
    if (modalsEmbedShow) {
      dispatch(openModal(EPredefinedModalIds.MODAL_EMBED_LEGENDS));
    } else {
      dispatch(closeModal(EPredefinedModalIds.MODAL_EMBED_LEGENDS));
    }
  }, [dispatch, modalsEmbedShow]);

  return (
    <>
      <div className={s.buttonContainer}>
        <BaseButtonSquare
          className={s.collapseButton}
          icon={isModalEmbedLegendsOpened ? 'minus' : 'plus'}
          size="2"
          svgSize="3"
          theme="flat-ashy"
          onClick={handleCloseClick}
        />
      </div>
      <div className={s.modalContainer}>
        <BaseGenericModal
          inline={true}
          size={EModalSize.S160}
          modalId={EPredefinedModalIds.MODAL_EMBED_LEGENDS}
          className={s.modal}
          modalRef={modalRef}>
          <div className={s.contentContainer}>
            <>
              {legends.map((legend, index) => (
                <div
                  onClick={() => console.log('todo')}
                  className={classnames(s.legendContainer, {
                    [s.marginBottom]: index !== legends.length - 1,
                  })}
                  key={index}>
                  <div className={s.logo} style={{ background: legend.color }} />
                  <h3 className={s.title}>{legend.title}</h3>
                </div>
              ))}
            </>
          </div>
        </BaseGenericModal>
      </div>
    </>
  );
};
